/**
 * Module: ui
 * General ui behaviors
 */

function init() {
	// Toggle active state
	$('[data-toggle-active]').on('click', function(e) {
		e.preventDefault();
		var target = $(this).data('toggle-active');
		$(this).toggleClass('active');
        $(target).toggleClass('active');
	});

    // Search toggle
    $('.header__toggle--search').on('click', function(e) {
        console.log('clicked');
        $('.header .form__search input').focus();
    });
}

/**
 * Public API
 * @type {Object}
 */
module.exports = {
	init: init
};


// WEBPACK FOOTER //
// ./scripts/components/ui.js